





import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";

import { Treenode } from "@/definitions/treenode"

@Component({
  components: {
  }
})
export default class UnderLine extends Vue {

  @Prop()
  private treeNode!: Treenode;

  position = "absolute"
  opacity = 0.1
  left = 0
  top = -5
  height = 10

  overed = false

  onMouseOver(event : MouseEvent){
      this.$nextTick(()=>{
    //       this.position = "fixed"
    //   this.opacity = 1
    // //   this.left = event.clientX
    //   this.top = event.clientY - 10
    //   this.height = 20
    //   this.overed = true
      })
      
  }

  onMouseLeave(){
      this.$nextTick(()=>{
          if(this.overed){
    //                   this.position = "absolute"
    //   this.opacity = 0.1
    //   this.left = 0
    //   this.top = -5
    //   this.height = 10
    //   this.overed = false
          }
    
      })
      
    
  }

  get topLineStyle(){
    let minus = 8 * this.treeNode.data.hierarchy + "px"

    return {
        "position" : this.position,
        "width" : "calc(100% - " + minus + ")",
        "opacity" : this.opacity,
        "top" : this.top + "px",
        "left" : this.left + "px",
        "height" : this.height + "px"
    }
  }

    

//   onMouseUp(){
//       alert(1)
//   }

  visible(){

  }

  

  

  onMouseUp(event){
      this.$emit("onDropObjectTree" , { node : this.treeNode , placement : "before" } , event)
  }

}
